import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Copilot API client
 * Handles all communication with agent endpoints
 */
export const copilotApi = {
  /**
   * Send a message to the Copilot agent
   * @param {string} message - User message
   * @param {object} context - Current context (module, path, entity, filters)
   * @param {string} token - Auth token
   * @param {string} conversationId - Optional conversation ID for persistence
   */
  sendMessage: async (message, context, token, conversationId = null) => {
    const response = await axios.post(
      `${API_URL}/api/agent/message`,
      { message, context, conversation_id: conversationId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  /**
   * Get user's conversation history
   * @param {string} token - Auth token
   */
  getConversations: async (token) => {
    const response = await axios.get(
      `${API_URL}/api/agent/conversations`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  /**
   * Get full conversation by ID
   * @param {string} conversationId - Conversation ID
   * @param {string} token - Auth token
   */
  getConversation: async (conversationId, token) => {
    const response = await axios.get(
      `${API_URL}/api/agent/conversations/${conversationId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  /**
   * Delete a conversation
   * @param {string} conversationId - Conversation ID
   * @param {string} token - Auth token
   */
  deleteConversation: async (conversationId, token) => {
    const response = await axios.delete(
      `${API_URL}/api/agent/conversations/${conversationId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  /**
   * Search conversations by keyword
   * @param {string} query - Search query
   * @param {string} token - Auth token
   */
  searchConversations: async (query, token) => {
    const response = await axios.get(
      `${API_URL}/api/agent/conversations/search/${encodeURIComponent(query)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  /**
   * Log a clarification Q/A pair
   * @param {object} data - Clarification data
   * @param {string} token - Auth token
   */
  logClarification: async (data, token) => {
    const response = await axios.post(
      `${API_URL}/api/agent/clarifications`,
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  /**
   * Create a proposed learning
   * @param {object} data - Proposed learning data
   * @param {string} token - Auth token
   */
  proposeLearning: async (data, token) => {
    const response = await axios.post(
      `${API_URL}/api/agent/propose-learning-full`,
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  /**
   * Add item to improvement backlog
   * @param {object} data - Backlog item data
   * @param {string} token - Auth token
   */
  addToBacklog: async (data, token) => {
    const response = await axios.post(
      `${API_URL}/api/agent/backlog`,
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
};

export default copilotApi;
